export default __webpack_public_path__ + "static/media/blocks1.87d45029.png";